<template>
  <div :class="statusClass">{{(cliente.active || cliente.value) ? 'Ativo' : 'Inativo'}}</div>
</template>

<script>

export default {
  name: 'StatusCliente',
  props: ['cliente'],
  computed: {
    statusClass () {
      let css = ['cliente-status']
      if (this.cliente.active || this.cliente.value) {
        css.push('text-positive')
      } else {
        css.push('text-negative')
      }
      return css
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus">
  .cliente-status{
    &.text-positive{
      color #009505 !important
    }
    &.text-warning{
      color #956300 !important
    }
    &.text-negative{
      color #EF0505 !important
    }
  }
</style>
